import { Injectable } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { SnackBarIconService } from '../shared/snack-bar-icon/snack-bar-icon.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { Category } from '../models/category';
import { Lot } from '../models/lot';
import { ProductPrice } from '../models/product';

@Injectable({
  providedIn: 'root'
})
export class ProductPriceService {

  public spinner: boolean = false;

  public currentProductLot: Lot;
  public currentProductPrice: Lot;

  public productPriceDataSource: MatTableDataSource<any>;
  public arrayCategories: any[];

  constructor(
    private fb: FormBuilder,
    private db: AngularFirestore,
    private snackBar: SnackBarIconService
  ) { }

  //to remove
  loadProductPrices(lot_id, _sort) {
    return this.db.collection<ProductPrice>('sbccv_product_prices', ref => ref.where('lot_id', '==', lot_id)).snapshotChanges()
      .subscribe((result) => {
        let array = result.map(item => {
          let price = new ProductPrice();
          price.id = item.payload.doc.id;
          price.category_id = item.payload.doc.data().category_id;
          price.category_name = item.payload.doc.data().category_name;
          price.value = item.payload.doc.data().value;
          return price;
        });

        this.productPriceDataSource = new MatTableDataSource(array);
        this.productPriceDataSource.sort = _sort;
        this.productPriceDataSource.sort.active = "category_name"
        this.productPriceDataSource.sort.direction = "asc"
        this.productPriceDataSource.filter = ""//funciona como um refresh
      },
        (error) => {
          console.log(JSON.stringify(error))
          this.snackBar.openSnackBar("Load Lot Prices error", '', 'error');
        })
  }



  createPriceForm() {
    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      lot_id: new FormControl(this.currentProductLot.id, [Validators.required]),
      lot_name: new FormControl(this.currentProductLot.name, [Validators.required]),
      category_id: new FormControl(''),
      category_name: new FormControl(''),
      value: new FormControl('', [Validators.required]),
      docList:  new FormControl(''),
    });

    return form
  }

  loadCategories() {

    return this.db.collection<Category>('sbccv_categories', ref => ref.orderBy('name')).snapshotChanges()
      .subscribe((result) => {
        this.arrayCategories = result.map(item => {
          let category = new Category();
          category.id = item.payload.doc.id;
          category.name = item.payload.doc.data().name;
          return category;
        });
      },
        (error) => {
          console.log(JSON.stringify(error))
          this.snackBar.openSnackBar("load category error", '', 'error');
        })
  }

  insert(productPrice) {

    console.log("insert productPrice: " + JSON.stringify(productPrice));

    delete productPrice.id
    this.spinner = true;

    return this.db.collection('sbccv_product_prices').add(Object.assign({}, productPrice))
      .then(() => {
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
        // return result.id
      })
      .catch((error) => {
        console.log("insert product lot error: " + error)
        let msgError: string = this.makeMsgError(error.details.code)
        this.snackBar.openSnackBar(msgError, '', 'error');
      })
      .finally(() => {
        this.spinner = false
      });
  }

  delete(id: any) {

    this.spinner = true;
    return this.db.collection('sbccv_product_prices').doc(id).delete()
      .then((e) => {
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch((error) => {
        console.log("delete price error" + error)
        this.snackBar.openSnackBar("Erro ao apagar preço", '', 'error');
      })
      .finally(() => {
        this.spinner = false;
      })
  }

  makeMsgError(errorsCode) {
    let msgError: string
    switch (errorsCode) {
      case "auth/email-already-exists":
        msgError = "Este email já está em uso"
        break;
    }
    return msgError
  }

}
